var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMan2ArmShaking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Man2ArmShaking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man2ArmShaking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.3675225,1.09051632 L5,21.9331805 L13.9847036,27 C22.165139,20.4659607 28.8906966,15.3079378 34.1613767,11.5259313 C34.7204589,2.48384704 30.4558408,-0.994624624 21.3675225,1.09051632 Z",
    id: "Fill-90",
    fill: "#ACACD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43239493,34.2043213 L1.43239493,34.2043213 C3.06275821,35.471776 5.44659219,35.1947045 6.73157327,33.5892618 L11.1956632,28.0104959 C12.4786536,26.4080008 12.1959777,24.0607532 10.5676051,22.7952636 C8.93724179,21.5287913 6.55340781,21.8048803 5.26842673,23.410323 L0.804336794,28.9881064 C-0.478653603,30.591584 -0.195977674,32.9388316 1.43239493,34.2043213",
    id: "Fill-108",
    fill: "#ED5353"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan2ArmShaking);
export default __webpack_public_path__ + "static/media/Man2ArmShaking.e2e50cefa27c682a6544f750770ac1a3.svg";
export { ForwardRef as ReactComponent };